module.exports = __webpack_public_path__ + "static/media/select-arrow-transparent.64013097.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/select-arrow-transparent.png
 ** module id = 314
 ** module chunks = 0
 **/